var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("crear-actualizar-vacaciones"),
      _vm._v(" "),
      _c("VerReporte"),
      _vm._v(" "),
      _c(
        "h3",
        { staticClass: "primary--text" },
        [
          _c("v-icon", { attrs: { color: "primary" } }, [_vm._v("today")]),
          _vm._v(" Vacaciones\n  ")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _c("p", [
                _c("strong", [_vm._v("Nombre: ")]),
                _vm._v(
                  _vm._s(this.$storage.get("user").nombres) +
                    "\n        " +
                    _vm._s(this.$storage.get("user").ap_paterno) +
                    "\n        " +
                    _vm._s(this.$storage.get("user").ap_materno) +
                    "\n      "
                )
              ]),
              _vm._v(" "),
              _vm.fecha_ingreso ==
              "No existe registros de la fecha de su incorporación"
                ? _c("p", [
                    _c("strong", [_vm._v("Fecha de incorporación: ")]),
                    _vm._v(_vm._s(_vm.fecha_ingreso) + "\n      ")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.fecha_ingreso !=
              "No existe registros de la fecha de su incorporación"
                ? _c("p", [
                    _c("strong", [_vm._v("Fecha de incorporación: ")]),
                    _vm._v(
                      _vm._s(
                        _vm.$moment(_vm.fecha_ingreso).format("DD/MM/YYYY")
                      ) + "\n      "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("crud-table", {
                attrs: {
                  headers: _vm.headers,
                  url: _vm.url,
                  filters: _vm.filters,
                  "data-graphql": _vm.dataGraphql,
                  graphql: _vm.graphql,
                  initData: _vm.initData,
                  estiloCabecera: "estilo-cabecera-customizada"
                },
                scopedSlots: _vm._u([
                  {
                    key: "items",
                    fn: function(items) {
                      return [
                        _c(
                          "td",
                          {
                            staticClass: "text-xs-center",
                            attrs: {
                              id:
                                items.item.id_estado_programacion != 72
                                  ? "celda_morada"
                                  : ""
                            }
                          },
                          [_vm._v(_vm._s(items.item.periodo))]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "text-xs-center",
                            attrs: {
                              id:
                                items.item.id_estado_programacion != 72
                                  ? "celda_morada"
                                  : ""
                            }
                          },
                          [_vm._v(_vm._s(items.item.estado_programacion))]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "nowrap text-xs-center",
                            attrs: {
                              id:
                                items.item.id_estado_programacion != 72
                                  ? "celda_morada"
                                  : ""
                            }
                          },
                          [
                            _vm.bandera_alta_persona &&
                            items.item.id_estado_programacion == 72
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      color: "info",
                                      to:
                                        "programar/" + items.item.gestion_hasta,
                                      icon: "",
                                      title: "Ver detalle"
                                    }
                                  },
                                  [_c("v-icon", [_vm._v("remove_red_eye")])],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.bandera_alta_persona &&
                            items.item.id_estado_programacion != 72
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      color: "info",
                                      to:
                                        "programar/" + items.item.gestion_hasta,
                                      icon: "",
                                      title: "Programar"
                                    }
                                  },
                                  [_c("v-icon", [_vm._v("edit")])],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.bandera_alta_persona == false
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      color: "info",
                                      icon: "",
                                      title: "Ver detalle"
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.mensajeBajaPersona()
                                      }
                                    }
                                  },
                                  [_c("v-icon", [_vm._v("remove_red_eye")])],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  color: "#f3cb19",
                                  icon: "",
                                  title:
                                    "Ver reporte del cronograma de vacaciones de la gestión"
                                },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.verReporte(items.item, 2)
                                  }
                                }
                              },
                              [_c("v-icon", [_vm._v("picture_as_pdf")])],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4fef43ef", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fef43ef","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/vacaciones/Index.vue
// module id = null
// module chunks = 